import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';
import { AgentProfile } from '../_models/agent.profile';
import { REMEMBERMELABELS, SHAREDCONSTANTS, SEARCHVIEWLABELS } from '../_constants/constants';
import { RememberMeService } from '../_services/rememberme.service';
import { DetailsComponent } from './../details/details.component';

import { NotificationDialogComponent } from './../notification/notification.dialog.component';
import { DeleteCofirmationDialogComponent } from '../shared/delete-confirmation/delete-confirmation.dialog.component';

import { TranslatePipe } from '../shared/translate/translate.pipe';
import { TranslateService } from '../_services/translate.service';
import { LoaderService } from '../_services/loader.service';

export interface RememberMeDialogModel {
    subValue: string;
    opcoValue: string;
    selectedCountry:string;
    agentprofile: AgentProfile;
    rememberMeService: RememberMeService;
}

@Component({
    templateUrl: 'rememberme.dialog.component.html',
    providers: [TranslatePipe]
})

export class RememberMeComponent extends DialogComponent<RememberMeDialogModel, string> implements RememberMeDialogModel, OnInit {
  
    rememberMeService: RememberMeService;
    subValue: string;
    opcoValue: string;
    selectedCountry: string;
    agentprofile: AgentProfile;
    remembermelabels = REMEMBERMELABELS;



    page: number = 1;
    totalItems: number;
    rememberMeData: any = [];
    itemsPerPage : number = 10;
    isLoading:Boolean = false;
    offset:number = 0;
    recordStart:number = 0;
    recordEnd:number;
    currentPageItemsLength:number;
    fromDeleteAction:boolean = false;

    constructor(private ds: DialogService, private cdRef:ChangeDetectorRef, private translatePipe: TranslatePipe, private translateService: TranslateService, private loaderService: LoaderService) {
          super(ds);
    }

     ngOnInit(){ 
     this.fromDeleteAction = false;

         setTimeout(() => {
            this.getRememberMeData(1);
        });         
      }


      ngAfterViewChecked()
      {        
       
        this.rememberMeData = this.rememberMeData;
        this.isLoading = this.isLoading;
        this.totalItems = this.totalItems;
        this.page = this.page;
        this.fromDeleteAction = this.fromDeleteAction;
      }


      deleteDeleteRememberMe(seriesIdentifier, subValue, opcoValue){
        
        this.ds.addDialog(DeleteCofirmationDialogComponent, {
            title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
            message:this.translatePipe.transform("DELETE_REMEMBER_ME_COOKIE_CONFIRM_MESSAGE",'REMEMBERMELABELS'),
            okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
            cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
            .subscribe((isConfirmed)=>{
              //Get dialog result
              if(isConfirmed){

                this.loaderService.display(true);

                this.isLoading = true;        
                this.fromDeleteAction = true;


                this.rememberMeService.deleteRememberMeSingle(seriesIdentifier, subValue, opcoValue).subscribe(
                res => {
                    this.ds.addDialog(NotificationDialogComponent,
                    {
                        success: true,
                        message: this.translatePipe.transform("REMEMBER_ME_DATA_DELETE_SUCCESS_MESSAGE",'REMEMBERMELABELS')
                    });

                    this.page = (this.currentPageItemsLength == 1 && this.page!=1) ? this.page - 1 : this.page;
                                                     
                    this.getRememberMeData(this.page);
                },
                err => {

                      if(err.json().internalCode && this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){
                          this.ds.addDialog(NotificationDialogComponent, {
                              success: false,
                              message: new TranslatePipe(this.translateService).transform(err.json().internalCode,'API_ERROR')                   
                          });
                      } 
                      else{
                          this.ds.addDialog(NotificationDialogComponent, {
                              success: false,
                              message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
                          });
                      }

                      this.page = (this.currentPageItemsLength == 1 && this.page!=1) ? this.page - 1 : this.page;
                                                     
                      this.getRememberMeData(this.page); 
                });                
              }        
        });        

      }



      deleteDeleteRememberMeAll(subValue, opcoValue){


         this.ds.addDialog(DeleteCofirmationDialogComponent, {
            title: this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
            message:this.translatePipe.transform("DELETE_REMEMBER_ME_ALL_COOKIE_CONFIRM_MESSAGE",'REMEMBERMELABELS'),
            okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
            cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
            .subscribe((isConfirmed)=>{
              //Get dialog result
              if(isConfirmed){

                this.loaderService.display(true);
                this.isLoading = true;        
                this.fromDeleteAction = true;

                this.rememberMeService.deleteRememberMeAll(subValue, opcoValue).subscribe(

                  res => {
                      this.rememberMeData = [];
                      this.isLoading = false;
                      this.loaderService.display(false);
                                                  
                      this.ds.addDialog(NotificationDialogComponent,
                      {
                          success: true,
                          message: this.translatePipe.transform("REMEMBER_ME_DATA_DELETE_SUCCESS_MESSAGE",'REMEMBERMELABELS')
                      });
                  },
                  err => {

                          this.rememberMeData = []; 
                          this.isLoading = false;
                          this.loaderService.display(false);

                          if(err.json().internalCode && this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){
                              this.ds.addDialog(NotificationDialogComponent, {
                                  success: false,
                                  message: new TranslatePipe(this.translateService).transform(err.json().internalCode,'API_ERROR')                   
                              });
                          } 
                          else{
                              this.ds.addDialog(NotificationDialogComponent, {
                                  success: false,
                                  message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
                              });
                          }
                  });
              }        
        });

        

      }


      getRememberMeData = (event) => {
      
        this.isLoading = true;
        this.loaderService.display(true);
        this.offset = (event - 1) * this.itemsPerPage;
        
        
        this.rememberMeService.getRememberMeListData(event, this.subValue, this.opcoValue, this.itemsPerPage, this.offset).subscribe(
          (data) => {      
              this.page = event;
              //this.rememberMeData = data.items,
              this.rememberMeData = data.items.sort((a: any, b: any) => new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime()),
              this.totalItems = data.totalItems,
              this.isLoading = false,
              this.recordStart = (this.offset) + 1;
              this.recordEnd = (this.offset + this.itemsPerPage) - (this.itemsPerPage - parseInt(this.rememberMeData.length));
              this.currentPageItemsLength = this.rememberMeData.length;

              this.loaderService.display(false);
                                      
          },
          (err) => {
                this.rememberMeData = [];                              
                this.isLoading = false;
                this.loaderService.display(false);
               
                if((!this.fromDeleteAction) && (this.translateService.checkAPIErrorExistsByCode(err.json().internalCode))){
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: this.translatePipe.transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else if(err.json().internalCode && this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){

                  if(this.fromDeleteAction && err.json().internalCode == "NOT_FOUND"){
                    console.log("From delete action");
                  }
                  else{

                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translateService).transform(err.json().internalCode,'API_ERROR')                   
                    });
                  }                    
                }
                else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
                    });
                }                              
          },
          () => {
              
          }
        );

        return event;
  }
}



// WEBPACK FOOTER //
// ./src/app/rememberme/rememberme.dialog.component.ts